<div
  id="warehouse-handling-detail-page"
  class="card p-2 animate__animated"
  [ngClass]="cardClass"
  *ngIf="pageLoaded"
>
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    [urlName]="'columnsArray_warehouseHandlingDetail'"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>
<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #ContradictionModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "InventoryReconciliation" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body" [ngClass]="{ 'border-bottom': selectValue != null }">
    <div class="col-12 top-input-box">
      <label for="description" class="form-label m-0"
        >{{ "description" | translate }}:</label
      >
      <textarea
        id="description"
        type="text"
        class="form-control"
        [(ngModel)]="selectValue.description"
        placeholder="{{ 'WriteYourDescriptionHere' | translate }}"
      ></textarea>
    </div>
  </div>

  <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="
        resolveOneContradiction()
      "
    >
      <i class="bx bx-check"></i>
      {{ "Save" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-label-secondary me-sm-3 me-1"
      (click)="clearSelect()"
    >
      <i class="bx bx-eraser"></i>
      {{ "Clear" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #ContradictionAllModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "InventoryAllReconciliation" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body" [ngClass]="{ 'border-bottom': selectValue != null }">
    <div class="col-12 top-input-box">
      <label for="description" class="form-label m-0"
        >{{ "description" | translate }}:</label
      >
      <textarea
        id="description"
        type="text"
        class="form-control"
        [(ngModel)]="selectValue.description"
        placeholder="{{ 'WriteYourDescriptionHere' | translate }}"
      ></textarea>
    </div>
  </div>

  <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="
        resolveAllDiscrepancies(
          thisWarehouseHandling?.stockId,
          selectValue.description
        )
      "
    >
      <i class="bx bx-check"></i>
      {{ "Save" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-label-secondary me-sm-3 me-1"
      (click)="clearSelect()"
    >
      <i class="bx bx-eraser"></i>
      {{ "Clear" | translate }}
    </button>
  </div>
</ng-template>

<app-barcode-scanner
  #barcodeScanner
  (parentAction)="handleScannedBarcode($event)"
></app-barcode-scanner>
